import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { Add } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Button,
  Checkbox,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import NoDataPlaceholder from "app/shared/NoDataPlaceholder";
import CheckboxItem from "app/shared/widgets/WeeklySales/components/CheckboxItem";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ShoppingCartCheckoutSharpIcon from "@mui/icons-material/ShoppingCartCheckoutSharp";
import TableSkeleton from "app/shared/widgets/TableSkeleton";
import StoneTableViewWIthAGRFormat from "app/shared/StoneTableViewWIthAGRFormat";
import ExcelGenerateForSearch from "app/shared/ExcelGenerate";
import { ExcelGenerateAdmin } from "app/shared/ExcelGenerate/ExcelGenerateForSearch";
// import { DataGrid } from '@mui/x-data-grid';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
// const columns = [
//   { field: 'id', headerName: 'ID', width: 70 },
//   { field: 'firstName', headerName: 'First name', width: 130 },
//   { field: 'lastName', headerName: 'Last name', width: 130 },
//   {
//     field: 'age',
//     headerName: 'Age',
//     type: 'number',
//     width: 90,
//   },
//   {
//     field: 'fullName',
//     headerName: 'Full name',
//     description: 'This column has a value getter and is not sortable.',
//     sortable: false,
//     width: 160,
//     valueGetter: (params) =>
//       `${params.row.firstName || ''} ${params.row.lastName || ''}`,
//   },
// ];

// const rows = [
//   { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
//   { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
//   { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
//   { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
//   { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
//   { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
//   { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
//   { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
//   { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
// ];

export default function SearchResult({
  searchformData,
  resultView = null,
  id = null,
  setRightComp = null,
  RightComp,
  fallBack = null,
  page,
  pageSize,
  rowCount,
  loading,
  handlePageSizeChange,
}) {
  const [SearchData, setSearchData] = useState(id);
  const { searchid } = useParams();
  const [Stoneresultdata, setStoneresultdata] = useState(resultView.result);
  const [Fl_red_flg, setFl_red_flg] = useState(resultView.v_flg);
  const [userParty, setUserParty] = useState(null);
  const [selectedStoneDetails, setSelectedStoneDetails] = useState({
    pcs: 0,
    cts: 0,
    rap: 0,
    disc: 0,
  });
  const [userSelectedParty, setUserSelectedParty] = useState(null);
  const [SelectedStone, setSelectedStone] = useState([]);
  const [SelectedStoneData, setSelectedStoneData] = useState([]);
  const [BLOADER, setBLOADER] = useState(false);
  const swal = useSwalWrapper();
  // const jumm = useJumboAuth()
  // console.log(jumm);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");
  // alert(isMobile);
  useEffect(() => {
      setRightComp(
        <>
          {isMobile ? (
            <>
              <Tooltip title={`(${Stoneresultdata?.length})Modify Search`}>
                <Fab
                  size="small"
                  variant="outlined"
                  onClick={() => fallBack(false)}
                  sx={{
                    display: "flex",
                    margin: "5px auto",
                    mt: 3,
                    ml: "auto !important",
                  }}
                  color="primary"
                >
                  <FilterAltIcon />
                </Fab>
              </Tooltip>
            </>
          ) : (
            <>
              <Button
                sx={{ ml: "auto !important" }}
                onClick={() => fallBack(false)}
                variant="outlined"
                startIcon={<FilterAltIcon fontSize={"30px"} />}
                color="primary"
              >
                Modify Search ({Stoneresultdata?.length})
              </Button>
            </>
          )}
          <ExcelGenerateAdmin text={"Excel"} data={SelectedStoneData} />
        </>
      );
  }, [Stoneresultdata, SelectedStoneData]);

  const fetchStoneresultdata = useCallback(() => {
    !Boolean(id) ? setSearchData(searchid) : setSearchData(id);
    jwtAuthAxios
      .post(`search/stone`, { ...searchformData, type: "save" })
      .then((res) => {
        // setStoneresultdata(res.data.data)
        // setFl_red_flg(res.data.v_flg)
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
    jwtAuthAxios
      .get(`master/helper?party=1`)
      .then((res) => {
        setUserParty(res.data?.data?.PARTY || []);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  }, [SearchData]);
  //   useEffect(()=>{
  // console.log('Fl_red_flg',Fl_red_flg);
  //   },[Fl_red_flg])
  const AddtoBasketHandler = useCallback(() => {
    setBLOADER(true);
    if (userSelectedParty) {
      jwtAuthAxios
        .post(`user/basket/add`, {
          stone_id: SelectedStone,
          party: userSelectedParty,
          type: "single",
        })
        .then((res) => {
          swal.fire({
            icon: "success",
            text: res.data.message,
          });
          navigate("/mybasket");
        })
        .catch((e) => {
          swal.fire({
            icon: "error",
            text: "Internal server Error",
          });
        })
        .finally(() => setBLOADER(false));
    } else {
      swal.fire({
        icon: "error",
        text: "Please Select Party",
      });
    }
  }, [SelectedStone, userSelectedParty]);

  useEffect(
    async (n) => {
      // console.log('SelectedStone',SelectedStone);
      let Data = await Stoneresultdata?.filter((s) =>
        SelectedStone?.includes(s.STONE)
      );
      setSelectedStoneData(Data);
    },
    [SelectedStone]
  );
  useEffect(() => {
    // console.log('SelectedStone',SelectedStoneData);
    if (SelectedStone && Stoneresultdata) {
      let ndata = SelectedStone?.flatMap((stone) =>
        Stoneresultdata.filter((s) => s.STONE === stone)
      );
      // console.log(ndata);
      let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0 };
      ndata?.forEach((sdata) => {
        tempCal = {
          pcs: tempCal.pcs + 1,
          cts: tempCal.cts + sdata.CARATS,
          rap: Number(tempCal.rap) + Number(sdata.RAP_PRICE),
          disc: Number(tempCal.disc) + Number(sdata.ASK_DISC),
          Gdisc: Number(tempCal.disc) + Number(sdata.GREEN_DISC),
          Rdisc: Number(tempCal.disc) + Number(sdata.RED_DISC),
        };
      });
      tempCal = {
        pcs: tempCal.pcs,
        cts: tempCal.cts,
        rap: Number(tempCal.rap) / Number(tempCal.pcs),
        disc: Number(tempCal.disc) / Number(tempCal.pcs),
        // Gdisc: Number(tempCal.Gdisc) / Number(tempCal.pcs),
        // Rdisc: Number(tempCal.Rdisc) / Number(tempCal.pcs),
      };
      tempCal = {
        ...tempCal,
        price: Number(tempCal.rap) - (tempCal.rap * tempCal.disc) / 100,
        // Gprice: Number(tempCal.rap) - (tempCal.rap * tempCal.Gdisc / 100),
        // Rprice: Number(tempCal.rap) - (tempCal.rap * tempCal.Rdisc / 100)
      };
      // console.log(tempCal);
      tempCal.pcs != 0 &&
        setSelectedStoneDetails({
          ...tempCal,
          amt: tempCal.price * tempCal.cts,
          // Gamt: tempCal.Gprice * tempCal.cts,Ramt: tempCal.Rprice * tempCal.cts
        });
    }
  }, [SelectedStoneData]);

  useEffect(() => {
    fetchStoneresultdata();
  }, []);

  return (
    <div>
      <Grid container>
        {/* <Grid item lg={3}>
        {fallBack ?<Button onClick={()=>fallBack(false)} variant="outlined" startIcon={<FilterAltIcon  fontSize={'30px'} />}  color='primary'>Modify Search ({Stoneresultdata?.length})</Button>:<Typography variant='h1'> Search Result({Stoneresultdata?.length})</Typography>}
        </Grid> */}
        <Grid item lg={12} xs={12} sx={{ mb: 3, justifyContent: "end" }}>
          {Array.isArray(userParty) && (
            <Stack
              direction={"row"}
              style={{ justifyContent: "end" }}
              spacing={{ xs: 1, sm: 2, md: 4 }}
            >
              {/* <ExcelGenerateAdmin  text={'Excel'} data={SelectedStoneData} /> */}
              {/* <ExcelGenerateForSearch  data={SelectedStoneData} /> */}
              <FormControl
                fullWidth
                sx={{ m: 1, maxWidth: "350px", width: "100%" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Party</InputLabel>
                <Select
                  labelId="demo-select-small"
                  label="Party"
                  onChange={(event) => setUserSelectedParty(event.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {userParty.map((party) => (
                    <MenuItem
                      value={party.FL_PARTY_CODE}
                      key={party.FL_PARTY_CODE}
                    >
                      {party.FL_PARTY_NAME}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* {Array.isArray(userParty) && <Autocomplete
                disablePortal
                id="combo-box-demo"
                value={(option) => option.FL_PARTY_CODE}
                getOptionLabel={(option) => option.FL_PARTY_NAME}
                options={userParty}
                sx={{width: 300}}
                onChange={(e)=>console.log(e.target.value)}
                renderInput={(params) => <TextField {...params} label="Select Party"/>}
            />} */}
              {isMobile ? (
                <LoadingButton
                  loading={BLOADER}
                  variant="contained"
                  disabled={!SelectedStone.length > 0 || !userSelectedParty}
                  onClick={AddtoBasketHandler}
                  sx={{ display: "flex", margin: "0 0px 22px auto" }}
                  color="primary"
                >
                  <ShoppingCartCheckoutSharpIcon />
                </LoadingButton>
              ) : (
                <LoadingButton
                  loading={BLOADER}
                  variant="contained"
                  disabled={!SelectedStone.length > 0 || !userSelectedParty}
                  onClick={AddtoBasketHandler}
                  sx={{ display: "flex", margin: "0 0px 22px auto" }}
                  startIcon={<ShoppingCartCheckoutSharpIcon />}
                  color="primary"
                >
                  Add To Basket
                </LoadingButton>
              )}
            </Stack>
          )}
        </Grid>
      </Grid>
      <StoneTableViewWIthAGRFormat
        Fl_red_flg={Fl_red_flg}
        Stoneresultdata={Stoneresultdata}
        setStoneresultdata={setStoneresultdata}
        selectedStoneDetails={selectedStoneDetails}
        SelectedStone={SelectedStone}
        setSelectedStone={setSelectedStone}
        page={page}
        pageSize={pageSize}
        rowCount={rowCount}
        loading={loading}
        handlePageSizeChange={handlePageSizeChange}
      />
    </div>
  );
}
